import { render, staticRenderFns } from "./makes.vue?vue&type=template&id=1bfb442f"
import script from "./makes.vue?vue&type=script&lang=js"
export * from "./makes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MakesItemPopular: require('/var/www/components/makes/makes-item-popular.vue').default,MakesItem: require('/var/www/components/makes/makes-item.vue').default})
